/**
 * Public runtime configuration.
 *
 * Every value here is inlined into the client bundle, so nothing secret may
 * live in this file. Server-only secrets belong in a separate module that is
 * never imported from a Client Component.
 */

function required(name: string, value: string | undefined): string {
  if (!value) {
    throw new Error(
      `Missing environment variable ${name}. Copy .env.example to .env.local and fill it in.`,
    );
  }
  return value;
}

export const env = {
  /**
   * MainApp, the directory service: accounts, businesses, memberships and
   * invitations. Every tenant's own data lives on the server it names, which
   * is learned at sign-in rather than configured here.
   */
  mainAppUrl: required(
    "NEXT_PUBLIC_MAINAPP_URL",
    process.env.NEXT_PUBLIC_MAINAPP_URL,
  ),
  // Browser key for Places and the map embed on the settings screen. It is in
  // the bundle by design; restrict it by HTTP referrer in the Google console,
  // which is the only thing stopping someone else spending it. Without one the
  // address is typed by hand instead.
  googleMapsApiKey: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY ?? "",

  stripePublishableKey: process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY ?? "",
  firebase: {
    apiKey: required(
      "NEXT_PUBLIC_FIREBASE_API_KEY",
      process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
    ),
    authDomain: required(
      "NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN",
      process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
    ),
    projectId: required(
      "NEXT_PUBLIC_FIREBASE_PROJECT_ID",
      process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
    ),
    storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET ?? "",
    messagingSenderId:
      process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID ?? "",
    appId: required(
      "NEXT_PUBLIC_FIREBASE_APP_ID",
      process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
    ),
  },
  analytics: {
    gaMeasurementId: process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID ?? "",
    metaPixelId: process.env.NEXT_PUBLIC_META_PIXEL_ID ?? "",
  },
} as const;
